import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { RegistryService } from '../registry/registry.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Settings } from '../settings/settings';
import { Guest, Website } from '../website-builder/wedding';
import { Registry } from '../registry/registry';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Gift } from '../gift/gift';
import { RegistryStateStore } from '../registry/registry.state.store';
import { GuestStateStore } from '../guest-list/guest.state.store';
import { state } from '@angular/core/src/animation/dsl';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';

import { default as defaultWebsiteCeline } from '../website-template-celine/default-data';
import { default as defaultWebsiteLottie } from '../website-template-lottie/default-data';
import { Contribution } from '../track/contribution';
import { UserService } from '../user/user.service';
import { MegaMenuComponent } from '../mega-menu/mega-menu.component';
@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit, AfterViewInit {
  @ViewChild('content') content: ElementRef;
  @ViewChild('megaMenu') megaMenuComponent: MegaMenuComponent;
  settings: Settings;
  registry: Registry;
  website: Website
  regUrlCopied: boolean;
  selectedEvent:string;
  attending = 0;
  webUrlCopied: boolean;
  totalContributionsAmountToday: number =0;
  avgContributionAmount: number =0;
  totalContributionAmount: number =0;
  weddingDate: Date;
  checklist: {
    website: {
      welcomeSectionUpdate: boolean,
      urlUpdated: boolean,
      guestAdded: boolean,
      rsvpSetup: boolean,
      launched: boolean
      percent: number;
    },
    registry: {
      giftAdded: boolean,
      regIntroUpdated: boolean,
      regImageUpdated: boolean,
      paymentMethodAdded: boolean,
      launched: boolean
      percent: number;
    }

  }
  gifts: Gift[];
  guests: Guest[];
  contributions: Contribution[];
  paidContributions: Contribution[];
  currentPosition: any;
  hideMobileMenu: boolean;
  acceptancePerCent: number = 0 
  invited: any;
  declined: any;
  awaiting: any;
  noOfContributions: number =0;
  invitedPlusOne:  number =0;;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {

    let scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;

  }

  constructor(
    private registryService: RegistryService,
    private router: Router,
    private route: ActivatedRoute,
    private settingsStateStore: SettingsStateStore,
    private registryStateStore: RegistryStateStore,
    private regisrtryFirebaseSevice: RegistryFirebaseService,
    private guestStateStore: GuestStateStore,
    private _weddingWebsiteStateStore: WebsiteStateStore,
    private _registryFirebaseService: RegistryFirebaseService,
    private _userService: UserService

  ) { 

  }

  ngOnInit() {


    document.title = 'Hitchd | Overview';
    this.checklist = {

      registry: {
        percent: 0,
        giftAdded: false,
        regIntroUpdated: false,
        regImageUpdated: false, // add logic to check if registry image is set
        paymentMethodAdded: false, // add logic to check if payment method is added
        launched: false
      },
      website: {
        guestAdded: false, // add logic to check if guests are added
        rsvpSetup: false, // add logic to check if rsvp is setup
        launched: false, // add logic to check if website is published
        urlUpdated: false, // add logic to check if website url is updated
        welcomeSectionUpdate: false, // add logic to check if welcome section is updated
        percent: 0,
      }
    }
    if (this.router.url === '/overview/setup') {
      this.registryService.emitGenricPopup("setup");
    }

    this.registryService.emitGenricPopup(null);

    this.registry = this.route.snapshot.data.registry;
    this.gifts = this.route.snapshot.data.gifts;
    this.settings = this.route.snapshot.data.settings;
    this.website = this.route.snapshot.data.website;

    if(Object.keys(this.website).length == 0){
      this.website = null;
    }

    if(this.website && Object.keys(this.website).length > 0 && this.website.weddingEvents && this.website.weddingEvents.length > 0){
      this.selectedEvent = this.website.weddingEvents[0].eventName
    }
    
    this.contributions = this.route.snapshot.data.contributions;
    this.processDate();
    if (this.contributions && this.contributions.length > 0) {
      this.paidContributions = this._registryFirebaseService.getContributionsbyStatus(this.contributions, 'paid');

      if (this.paidContributions && this.paidContributions.length > 0) {
        this.totalContributionAmount = this.paidContributions.map(x => x.giftTotal).reduce((a, b) => a + b);

        this.totalContributionsAmountToday = this.paidContributions.filter(x => {
          return new Date(x.createdDate).toDateString() === new Date().toDateString();
        }
        ).map(x => x.giftTotal).reduce((a, b) => a + b, 0);

        this.avgContributionAmount = this.totalContributionAmount / this.paidContributions.length;
        this.noOfContributions = this.paidContributions.length;
      }



    }
this.refreshTotals();
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.settingsStateStore.getState().subscribe(state => {
      this.settings = state.settings;


      if(this.settings && this.settings.dismissOverviewIntro){
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'auto';
      }
    });









    this.registryStateStore.getState().subscribe(state => {
      this.registry = state.registry;
      this.processDate();
      this.gifts = state.gifts;
      this.setRegistryCheckList();
    })
    this._weddingWebsiteStateStore.getState().subscribe(state => {
      if (state && state.website && Object.keys(state.website).length > 0) {
        this.website = state.website;
        
        if (!this.selectedEvent &&  this.website && this.website.weddingEvents && this.website.weddingEvents.length > 0) {
          this.selectedEvent = this.website.weddingEvents[0].eventName;
          this.refreshTotals();
        }
        
        this.setWebsiteCheckList();
      }
    })
    localStorage.removeItem('sectionName');

  }
  triggerShowTranslatePopup() {
    this.megaMenuComponent.showTranslatePopup();
  }
  openVisibilityLink() {
    return this.regisrtryFirebaseSevice.openVisibility(this.router, this.registry, this.website);
  }

  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  processDate() {
    if (this.registry && this.registry.weddingDay && this.registry.weddingMonth && this.registry.weddingYear) {

      this.weddingDate = new Date(
        this.registry.weddingYear,
        this.registry.weddingMonth - 1,
        this.registry.weddingDay,
        0,
        0,
        0,
        0
      );
    }
  }

  refreshTotals() {
    this.guestStateStore.getState().subscribe(state => {
      if (state && state.guests) {
        this.guests = state.guests;
        this.attending = 0;
        this.invited = 0;
        this.declined = 0;
        this.invitedPlusOne = 0;
  
        if (!this.website || !this.website.weddingEvents || this.website.weddingEvents.length === 0) {
          return;
        }
  
        const selectedEvent = this.website.weddingEvents.find(event => event.eventName === this.selectedEvent);
        if (!selectedEvent) {
          return;
        }
  
        const eventId = selectedEvent.id;
  
        this.guests.forEach(guest => {
          let status = (guest.rsvpStatus && guest.rsvpStatus[eventId]) !== undefined ? guest.rsvpStatus[eventId] : null;
          switch (status) {
            case 'invited':{
              this.invited++;
              if(guest.canBringPlusOne){
                this.invitedPlusOne++;
              }            
              break;
            }
            case 'attending':
              this.attending++;
              break;
            case 'declined':
              this.declined++;
              break;
   
          }
     
        });

        let totalGuests = this.invited+this.attending+this.declined;
        if(totalGuests > 0){        
        this.acceptancePerCent = Math.round((this.attending / totalGuests) * 100) || 0;
        } else {
          this.acceptancePerCent = 0;
        }

      }

    });

   
  }
  onContentScrolled(e: any) {
    console.log("SCROLLED")
    let scroll = e.target.scrollTop;



    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;
    this.logger(scroll);

  }
  logger(scroll) {
    console.log({
      currentPosition: this.currentPosition,
      scroll: scroll,
      hideMobileMenu: this.hideMobileMenu,
      loggic: (document.documentElement.scrollHeight - 400) < (scroll + window.innerHeight)

    })
  }
  ngAfterViewInit() {
    // this.content.nativeElement.addEventListener('scroll', this.onContentScrolled.bind(this));
    let exists = document.getElementsByClassName('modal-hide-scroll');
    if(exists && exists.length > 0){
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';
    
    }
  }
  getDefaultWebsiteTemplate(templateName: string) {
    switch (templateName) {
      case 'celine':
        return defaultWebsiteCeline;
      case 'lottie':
        return defaultWebsiteLottie;
      default:
        return defaultWebsiteCeline;
    }
  }



  setRegistryCheckList() {
    if (!this.registry) {
      return;
    }
    this.checklist.registry.giftAdded = this.gifts ? this.gifts.length > 0 : false;
    this.checklist.registry.regIntroUpdated = this.registry.introductionText != "We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead."
    this.checklist.registry.regImageUpdated = this.registry.backgroundHeaderImageUrl ? !this.registry.backgroundHeaderImageUrl.includes('https://images.unsplash.com/photo-1527904219733-fddc74937915') : false
    this.checklist.registry.paymentMethodAdded = this.registry.hasCustomPaymentMethods || (this.settings && this.settings.stripeAccountId != null);
    this.checklist.registry.launched = this.registry.isLive;
    this.checklist.website.urlUpdated = !this.regisrtryFirebaseSevice.doesUrlContainDefaultWords(this.registry.registryName)
    this.checklist.registry.percent = 0;
    Object.keys(this.checklist.registry).forEach(key => {
      if (this.checklist.registry[key] && key !== 'percent') {
        this.checklist.registry.percent = this.checklist.registry.percent + 20;
      }
    });
  }

  setWebsiteCheckList() {



    if (this.website && Object.keys(this.website).length > 0) {
      this.checklist.website.rsvpSetup = this.website.weddingEvents && this.website.weddingEvents.some(x => x.collectRsvpsOnWebsite)
      this.checklist.website.launched = this.website.isLive;
      let defaultTemplate = this.getDefaultWebsiteTemplate(this.website.template);
      if (this.website.welcome.eventDisplayName == defaultTemplate.welcome.eventDisplayName
        && this.website.welcome.eventLocation == defaultTemplate.welcome.eventLocation
        && this.website.welcome.heroImageUrl == defaultTemplate.welcome.heroImageUrl
        && this.website.welcome.greetings == defaultTemplate.welcome.eventLocation
        && this.website.welcome.isEnabled == defaultTemplate.welcome.isEnabled
      ) {


        this.checklist.website.welcomeSectionUpdate = false;
      } else {
        this.checklist.website.welcomeSectionUpdate = true;
      }

    }
    this.checklist.website.guestAdded = this.guests && this.guests.length > 0;
    this.checklist.website.percent = 0;
    Object.keys(this.checklist.website).forEach(key => {
      if (this.checklist.website[key] && key !== 'percent') {
        this.checklist.website.percent = this.checklist.website.percent + 20;
      }
    });

    //count if each of the registry.checklist properties are true and increment the registry.percent by 20 for each one that is true 

  }
  launchRegClick() {
    if (!this.registry.paid && (!this.registry.hasCustomPaymentMethods)) {
      this.router.navigate(['/registry/add-payment-methods']);
    } else if (!this.registry.paid && (this.registry.hasCustomPaymentMethods)) {
      this.router.navigate(['/visibility']);
    } else {
      this.router.navigate(['/registry/publish/step-3']);
    }
  }


  copyRegistry() {
    this.regUrlCopied = true;
    if (this.settings.weddingWebsiteEnabled) {
      this.setClipboardText("https://www.hitchd.com/" + this.registry.registryName + "/registry");

    }
    setTimeout(() => {
      this.regUrlCopied = false;
    }, 2 * 1000);
  }
  copyWebsite() {
    this.webUrlCopied = true;
    if (this.settings.weddingWebsiteEnabled) {
      this.setClipboardText("https://www.hitchd.com/" + this.registry.registryName);

    }
    setTimeout(() => {
      this.webUrlCopied = false;
    }, 2 * 1000);
  }



  setClipboardText(text) {
    const id = 'mycustom-clipboard-textarea-hidden-id';
    let existsTextarea: any = document.getElementById(id);

    if (!existsTextarea) {
      const textarea: any = document.createElement('textarea');
      textarea.id = id;
      // Place in top-left corner of screen regardless of scroll position.
      textarea.style.position = 'fixed';
      textarea.style.top = 0;
      textarea.style.left = '-10px';

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textarea.style.width = '1px';
      textarea.style.height = '1px';

      // We don't need padding, reducing the size if it does flash render.
      textarea.style.padding = 0;

      // Clean up any borders.
      textarea.style.border = 'none';
      textarea.style.outline = 'none';
      textarea.style.boxShadow = 'none';

      // Avoid flash of white box if rendered for any reason.
      textarea.style.background = 'transparent';
      document.querySelector('body').appendChild(textarea);

      existsTextarea = document.getElementById(id);
    } else {
    }

    existsTextarea.value = text;
    existsTextarea.select();

    try {
      const status = document.execCommand('copy');

      if (!status) {
      } else {



      }
    } catch (err) { }
  }

  openPopup(popupType) {

    ;
    this.registryService.emitGenricPopup(popupType);
  }
  toggleWebsite() {
    this.settings.weddingWebsiteEnabled = !this.settings.weddingWebsiteEnabled;

    if (this.settings.weddingWebsiteEnabled && (!this.website || Object.keys(this.website).length === 0)) {
      this._weddingWebsiteStateStore.initWebsite(this.settings.userId,this.registry, null, true, true);



    } else if (!this.settings.weddingWebsiteEnabled && this.website && this.website.isLive) {
      this.website.isLive = false;
      this._weddingWebsiteStateStore.updateWebsite(this.website);
    }
    this.saveSettings()
  }
  toggleRegistry() {
    this.settings.registryEnabled = !this.settings.registryEnabled;
    this.saveSettings()
  }

  dismissOverviewIntro() {
    this.settings.dismissOverviewIntro = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.saveSettings()
  }

  openVisibility(isRegistry:boolean) {
    if(isRegistry){
      this._registryFirebaseService.showMiniLaunchPopup(true, false);
  } else {
    this._registryFirebaseService.showMiniLaunchPopup(true, true);
  }
  }

  saveSettings() {
    this.settingsStateStore.updateSettings(this.settings);

  }

}



// WEBPACK FOOTER //
// ./src/app/overview/overview.component.ts